export const fnReportError = ({ message }) => {
  console.error(message);
};

export const fnThrowError = ({ message }) => {
  throw new Error(message);
};

export const getReadableError = (err, defaultMessage) => {
  // Deliberately not reading err.response.data, the body axios parks on a
  // non-2xx. Every response the backend uses to say something TO the member
  // goes out at 200 — JsonErrorResponse never calls setCode, and Sapien
  // defaults to 200 — so FnrFetch3 rejects with the body itself and the
  // branches below already have it. What's left on a non-2xx is
  // BadRequestResponse, and half of those are notes to a developer:
  // 'columnID', 'bad action', 'invalid params', and one that forwards a raw
  // $e->getMessage(). Betty must never be shown those.
  if (typeof err?.message === "string") return err.message;
  else if (typeof err === "string") return err;
  // Legacy endpoints split which key carries the prose: group/view rejects with
  // only {error: "Group not found"}, while addToGroupByAdmin puts a machine code
  // there ("invalidEmail") beside the sentence on `message` — so `message` is
  // checked first and this never surfaces a code. Guarded on string to keep the
  // name honest: an `error` holding an object is not readable, and stringifying
  // it is how "[object Object]" reached the caller in the first place.
  else if (typeof err?.error === "string") return err.error;
  return defaultMessage;
};

// The message stays clean because consumers render it straight to the user
// (Giving, RESetup, Network and others do `setErrorMessage(err.message)`), so
// prefixing the endpoint onto it would put internal URLs on screen. It rides as
// a property instead: react-query's default logger console.errors the Error
// object, so the endpoint is right there when debugging without ever being
// user-visible.
export const throwReadableError = (endpoint, err) => {
  const error = new Error(
    getReadableError(err, `Error at ${endpoint}: ${err}`)
  );
  error.endpoint = endpoint;
  throw error;
};
